import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ImageCarouselProps {
  images: string[];
  alt: string;
  /** Tailwind aspect ratio class. Defaults to 4:3. */
  ratio?: string;
}

/**
 * Simple single-image carousel. With one image it renders as a plain
 * image — no controls, no chrome.
 */
export function ImageCarousel({
  images,
  alt,
  ratio = 'aspect-[4/3]'
}: ImageCarouselProps) {
  const [index, setIndex] = useState(0);
  const many = images.length > 1;
  const go = (next: number) => setIndex((next + images.length) % images.length);
  return <div className={`relative w-full overflow-hidden ${ratio} bg-paper-warm`} data-id="element-78" data-mp="3gp2b66z3g5fo">
      <img src={images[index]} alt={alt} className="h-full w-full object-cover" data-id="element-79" data-mp="3ln3t2oks9ypk" />

      {many && <>
          <button type="button" onClick={() => go(index - 1)} aria-label="Previous image" className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-paper/90 text-coffee transition-colors hover:bg-paper" data-id="element-80" data-mp="d6sauxl0tgt7">
            <ChevronLeftIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-81" data-mp="rcdmmggj36j" />
          </button>
          <button type="button" onClick={() => go(index + 1)} aria-label="Next image" className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-paper/90 text-coffee transition-colors hover:bg-paper" data-id="element-82" data-mp="eih7t912339h">
            <ChevronRightIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-83" data-mp="jfpsbg9ofjdw" />
          </button>
          <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-1.5" data-id="element-84" data-mp="xf8nz9lax29b">
            {images.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Show image ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-colors duration-200 ${i === index ? 'w-5 bg-paper' : 'w-1.5 bg-paper/50'}`} data-id="element-85" data-mp="sel0uz0715kd" data-mpi={i} />)}
          </div>
        </>}
    </div>;
}